// ============================================================================
// vpn/VpnSessionsTable.tsx — журнал VPN-сессий (профиль/пользователь/статус/время).
// ============================================================================

export interface VpnSessionRow {
  id: string;
  profileCode: string;
  userId: string;
  status: string;
  clientInfo: string;
  connectedAt: string;
  disconnectedAt: string;
}

const STATUS_LABELS: Record<string, string> = {
  connected: 'Подключено', disconnected: 'Отключено', error: 'Ошибка',
};

export function VpnSessionsTable({ sessions }: { sessions: VpnSessionRow[] }) {
  return (
    <table className="w-full text-xs border-collapse">
      <thead className="bg-muted/60"><tr>
        <th className="text-left px-2 py-1.5">Профиль</th>
        <th className="text-left px-2 py-1.5">Пользователь</th>
        <th className="text-left px-2 py-1.5">Статус</th>
        <th className="text-left px-2 py-1.5">Подключено</th>
        <th className="text-left px-2 py-1.5">Отключено</th>
        <th className="text-left px-2 py-1.5">Клиент</th>
      </tr></thead>
      <tbody>
        {sessions.map((s) => (
          <tr key={s.id} className="border-t hover:bg-accent/5">
            <td className="px-2 py-1.5">{s.profileCode}</td>
            <td className="px-2 py-1.5 text-muted-foreground">{s.userId}</td>
            <td className="px-2 py-1.5">{STATUS_LABELS[s.status] || s.status}</td>
            <td className="px-2 py-1.5 whitespace-nowrap">{s.connectedAt}</td>
            <td className="px-2 py-1.5 whitespace-nowrap">{s.disconnectedAt || '—'}</td>
            <td className="px-2 py-1.5 text-muted-foreground">{s.clientInfo || '—'}</td>
          </tr>
        ))}
        {sessions.length === 0 && (
          <tr><td colSpan={6} className="px-2 py-4 text-center text-muted-foreground">Сессий нет</td></tr>
        )}
      </tbody>
    </table>
  );
}
